import React from "react";
import "./Carousel.css";

const Carousel = () => {
  return (
    <div className="Carousel">
      <div className="carouselImg c1"></div>
      <div className="carouselImg c2"></div>
      <div className="carouselImg c3"></div>
      <div className="carouselImg c4"></div>
      <div className="carouselImg c5"></div>
      <div className="carouselImg c6"></div>
      <div className="carouselImg c7"></div>
    </div>
  );
};

export default Carousel;
